'use client'
import Error500 from "components/_Pages/Error/500";

export default async function Page(context) {
    return <Error500/>;
}
